import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import { CreateVisitasDto } from '../../../types/visitas';
import ClienteSearch from '../../../components/Tesoreria/ClienteSearch';
import DireccionClienteSearch from '../../../components/Tesoreria/DireccionClienteSearch';

interface AppendVisitaDialogProps {
  open: boolean;
  saving?: boolean;
  onClose: () => void;
  onSubmit: (payload: CreateVisitasDto) => Promise<void>;
}

const AppendVisitaDialog: React.FC<AppendVisitaDialogProps> = ({
  open,
  saving = false,
  onClose,
  onSubmit,
}) => {
  const [nroCliente, setNroCliente] = useState('');
  const [clienteLabel, setClienteLabel] = useState('');
  const [clienteSearchOpen, setClienteSearchOpen] = useState(false);
  const [codigoDireccion, setCodigoDireccion] = useState('');
  const [direccionLabel, setDireccionLabel] = useState('');
  const [direccionSearchOpen, setDireccionSearchOpen] = useState(false);
  const [fechaHoraProgramada, setFechaHoraProgramada] = useState('');
  const [observaciones, setObservaciones] = useState('');

  useEffect(() => {
    if (!open) return;
    setNroCliente('');
    setClienteLabel('');
    setClienteSearchOpen(false);
    setCodigoDireccion('');
    setDireccionLabel('');
    setDireccionSearchOpen(false);
    setFechaHoraProgramada('');
    setObservaciones('');
  }, [open]);

  const handleSubmit = async () => {
    await onSubmit({
      nroCliente: Number(nroCliente),
      codigoDireccion: codigoDireccion.trim() || undefined,
      fechaHoraProgramada: fechaHoraProgramada || null,
      observaciones: observaciones || null,
    });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Agregar visita al plan</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="number"
                label="Número de Cliente"
                value={nroCliente}
                onChange={(e) => {
                  setNroCliente(e.target.value);
                  setClienteLabel('');
                  setCodigoDireccion('');
                  setDireccionLabel('');
                }}
                helperText={
                  clienteLabel ||
                  'Escriba el número o use el selector para buscar por nombre, CUIT, etc.'
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        color="primary"
                        title="Seleccionar cliente"
                        onClick={() => setClienteSearchOpen(true)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Código Dirección"
                value={codigoDireccion}
                onChange={(e) => {
                  setCodigoDireccion(e.target.value);
                  setDireccionLabel('');
                }}
                helperText={
                  direccionLabel ||
                  'Escriba el código o use el selector (requiere número de cliente).'
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        color="primary"
                        title="Seleccionar dirección"
                        disabled={!Number(nroCliente)}
                        onClick={() => setDireccionSearchOpen(true)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="datetime-local"
                label="Fecha/Hora Programada"
                InputLabelProps={{ shrink: true }}
                value={fechaHoraProgramada}
                onChange={(e) => setFechaHoraProgramada(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Observaciones"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!nroCliente || saving}>
            Agregar
          </Button>
        </DialogActions>
      </Dialog>

      <ClienteSearch
        open={clienteSearchOpen}
        onClose={() => setClienteSearchOpen(false)}
        onSelect={(cliente) => {
          setNroCliente(String(cliente.nroCliente));
          setClienteLabel(
            [cliente.nombre, cliente.razonSocial].filter(Boolean).join(' — ') || `Cliente ${cliente.nroCliente}`,
          );
          setClienteSearchOpen(false);
          setCodigoDireccion('');
          setDireccionLabel('');
        }}
      />

      <DireccionClienteSearch
        open={direccionSearchOpen}
        onClose={() => setDireccionSearchOpen(false)}
        nroCliente={Number(nroCliente) || 0}
        onSelect={(d) => {
          setCodigoDireccion(d.codigoDireccion);
          setDireccionLabel(d.direccion || '');
        }}
      />
    </>
  );
};

export default AppendVisitaDialog;
